import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // すべてのCookieを削除
    Cookies.remove('auth_token');
    Cookies.remove('user_info');
    Cookies.remove('token_info');

    // ブラウザのキャッシュをクリア（可能な範囲で）
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    // sessionStorageとlocalStorageをクリア
    sessionStorage.clear();
    localStorage.clear();

    // ログイン画面にリダイレクト
    setTimeout(() => {
      navigate('/login', { replace: true });
    }, 500);
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-indigo-600 border-r-transparent"></div>
        <p className="mt-4 text-lg font-medium text-gray-700">ログアウト中...</p>
      </div>
    </div>
  );
}
